import AXIOS from '@/utils/$axios';

export const createProject = payload =>
    AXIOS.post('/space/project/project/temp', payload);
